module.exports = __webpack_public_path__ + "img/imgs1.54da4c63.png";